import { render, staticRenderFns } from "./FullViewReport.vue?vue&type=template&id=56a573dd"
import script from "./FullViewReport.vue?vue&type=script&lang=js"
export * from "./FullViewReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports